<script setup lang="ts">
const carousels = [
  {
    title: 'Pesan Pengiriman Paket COD',
    description:
      'Pesan pengiriman paket dengan metode pembayaran COD melalui aplikasi atau dashboard KiriminAja'
  },
  {
    title: 'Paket Diterima Kurir',
    description:
      'Paket diambil atau diterima kurir untuk diantarkan ke pelanggan.'
  },
  {
    title: 'Paket Sampai Tujuan, Dana COD Rilis',
    description:
      'Pelanggan menerima paket dan membayar dana COD. KiriminAja akan merilis dana COD ke saldo aktif di hari yang sama dan dapat ditarik secara real time.'
  }
]
</script>

<template>
  <div class="bg-surface-container-low py-7 lg:py-16">
    <UiContainer class="flex flex-col gap-11">
      <UiSectionTitle
        class="text-center"
        title="Rilis Dana COD Cepat"
        title-as="h2"
        description="Dana COD dirilis ke saldo aktif di hari yang sama paket diterima pelanggan, dan selanjutnya dapat ditarik ke rekening secara real time."
      />
      <UiCarouselFeature :items="carousels" />
      <CtaBase />
    </UiContainer>
  </div>
</template>
